import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from 'react-i18next';

const OutsourcingSecurity7 = props => (
    <section id="outsourcing-security-section7" className="my pt-5">
        <div className='blue-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingSecurity:section-7.title')}</h2>
            <p className='mb-5'>
                <Trans i18nKey="services:outsourcingSecurity:section-7.txt"
                    components={{
                        br: <br />,
                        outsourcingAdvantages: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_advantages.path')} className="link" />
                    }}
                />
            </p>
            <div className="AccordionUI bg p-5 mb-5">
                {[1, 2, 3, 4, 5].map(item => (
                    <div key={item} className={item < 5 ? 'mb-5' : ''}>
                        <div className='d-flex align-items-center mb-4'>
                            <div className='arrow-container'>
                                <div className='arrow orange'>
                                    <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                                </div>
                            </div>
                            <h3 className='h5 fw-600 m-0 orange'>{props.t('services:outsourcingSecurity:section-7.' + item + '.title')}</h3>
                        </div>
                        <p className={item < 5 ? '' : 'm-0'}>{props.t('services:outsourcingSecurity:section-7.' + item + '.text')}</p>
                    </div>
                ))}
            </div>
            <p className='m-0'>{props.t('services:outsourcingSecurity:section-7.text')}</p>
        </Container>
    </section>
);

export default OutsourcingSecurity7;
